<template>
  <div id='vote'>
    <div class="head_boc">
      <h1>理财规划师大赛投票</h1>
      <div class="ballot">投票排名</div>
      <div class="personal_vote">个人投票剩余票数：{{VoteCnt}}</div>

      <div class="vote_rules" @click="isMat = !isMat">投票规则</div>
    </div>
    <div class="mat" v-show="!isMat">
      <img class="vote_img" @click="isMat = !isMat" :src="FullPath" alt="">
    </div>

    <div class="mat" v-show="!iscode">
      <img class="vote_img1" src="../assets/code.png" @click="iscode = !iscode"  alt="">
    </div>
    <!-- <div style="width: 100%;padding:10px 20px;box-sizing: border-box;text-align: center;border-bottom: 1px solid #3E1976;">
      <div style="display: flex;border: 1px solid #3E1976;border-radius: 30px;overflow: hidden;">
        <input placeholder="请输入姓名或编号" v-model="name" type="text" style="width: 100%;height: 30px;line-height: 30px;border: none;padding: 0 10px;box-sizing: border-box;">
        <button @click="searchFun" style="width: 80px;border:none;background-color: #3E1976;color: #fff;padding: 0;margin: 0;">搜索</button>
      </div>
    </div> -->

    <mt-loadmore :bottom-method="loadBottom" @bottom-status-change="handleBottomChange" :bottom-all-loaded="allLoaded"
      ref="loadmore">
      <div class="player_list">
        <div class="list" v-for="(item,index) in list" :key='index'>
          <div class="pic">
            <img class="pic_is" :src="item.Photo?item.RootPath+item.Photo:'/static/img/zanwu.807e212.jpg'" />
			<span class="Serial">编号:{{item.No}}</span>
          </div>
          <div class="name">{{item.UserName}}</div>
          <div style="color: #FF0000;font-size: 0.8rem;margin-bottom: 10px;">{{item.VoteCnt}}票</div>
          <button :disabled='isdisabled' class="vote_btn" @click="iscode = !iscode">投票</button>
        </div>
      </div>
    </mt-loadmore>
  </div>
</template>

<script>
  import {
    Loadmore
  } from 'mint-ui';

  import {
    MessageBox
  } from 'mint-ui';
  export default {
    data() {
      return {
        isMat: 1,
        iscode:1,
        allLoaded: false,
        FullPath: '',
        isdisabled:false,
        list: [],
        color: ["#12A3EA", "#FF0000", "#e91e63", "#5b1ee9", "#1ee925", "#9c27b0", "#12A3EA", "#FF0000", "#409EFF"],
        name: '',
        pageIndex: 1,
        pageSize: 12,
        VoteCnt: 0,
        autoFill: true
      }
    },
    created() {
      this.getVoteRules()
      this.getCompetitionUsers()
      localStorage.getItem('competition_cookie') ? this.VoteFrequency() : ""
    },

    methods: {
      handleBottomChange(status) {
        this.bottomStatus = status;
      },
      searchFun(){
        console.log(this.name)
        this.list = [],
        this.pageIndex= 1,
        this.pageSize= 12,
        this.getCompetitionUsers()
      },
      loadBottom() {
        setTimeout(() => {
          if (this.TotalItem >= this.list.length) {
            this.pageIndex++
            this.getCompetitionUsers()
          } else {
            this.allLoaded = true;
          }
          this.$refs.loadmore.onBottomLoaded();
        }, 1500);
      },
      VoteFrequency: function() {
        this.$http.get('/api/Vote/VoteFrequency')
          .then(res => {
            console.log(res)
            this.VoteCnt = res.data.data
          })
      },
      getVoteRules: function() {
        this.$http.get('/api/SiteSetting/GetVoteRules')
          .then(res => {
            console.log(res)
            this.FullPath = res.data.data.FullPath
          })
      },
      getCompetitionUsers: function() {
        this.$http.get('/api/Vote/GetCompetitionUsers?name=' + this.name + '&pageIndex=' + this.pageIndex +
            '&pageSize=' + this.pageSize)
          .then(res => {
            console.log(res.data)
            this.total = res.data.Success?res.data.data.length:0
            // this.list = res.data.data
            if(res.data.data){
              this.list = this.list.concat(res.data.data)
            }
            this.TotalItem = res.data.TotalItem
          })
      },
      VoteFun: function(Id, index) {
        console.log(Id)
        //消失动画效果
        // var btn = event.target
        // this.isdisabled = true


      },
    }
  }
</script>

<style scoped="scoped" lang="scss">
  #vote{
    font-size: 0.8rem;
  }
  .loading-background,
  .mint-loadmore-top span {
    -webkit-transition: .2s linear;
    transition: .2s linear;
  }

  .mint-loadmore-top span {
    display: inline-block;
    vertical-align: middle;
  }

  .mint-loadmore-top span.is-rotate {
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg);
  }

  .page-loadmore .mint-spinner {
    display: inline-block;
    vertical-align: middle
  }

  .page-loadmore-desc {
    text-align: center;
    color: #666;
    padding-bottom: 5px
  }

  .page-loadmore-desc:last-of-type,
  .page-loadmore-listitem {
    border-bottom: 1px solid #eee
  }

  .page-loadmore-listitem {
    height: 50px;
    line-height: 50px;
    text-align: center
  }

  .page-loadmore-listitem:first-child {
    border-top: 1px solid #eee
  }

  .page-loadmore-wrapper {
    overflow: scroll
  }

  .mint-loadmore-bottom span {
    display: inline-block;
    -webkit-transition: .2s linear;
    transition: .2s linear;
    vertical-align: middle
  }

  .mint-loadmore-bottom span.is-rotate {
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg)
  }

  #vote {
    position: relative;
    // height: 100vh;

    .mat {
      width: 100vw;
      height: 100vh;
      position: fixed;
      z-index: 9999999;
      top: 0;
      left: 0;
      background: rgba(225, 225, 225, .5);
    }
    .vote_img1 {
      position: absolute;
      width: 50%;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      margin: auto;
    }
    .vote_img {
      position: absolute;
      width: 90%;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      margin: auto;
    }

    .head_boc {
      width: 100%;
      height: 12rem;
      background: url("../assets/1.jpg") no-repeat;
      background-position: center;
      background-size: cover;
      color: #fff;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      padding: 20px 0;
      position: relative;

      .vote_rules {
        position: absolute;
        top: 3rem;
        right: 20px;
        border-bottom: 1px solid #fff;
      }

      h1 {
        font-size: 1rem;
        text-align: center;
        font-weight: bold;
      }

      .ballot {
        text-align: center;
        color: #fff3ab;
        font-size: 0.8rem;
        font-weight: bold;
        text-shadow: 0px 0px 5px #fff3ab
      }

      .personal_vote {
        text-align: center;
        width: 200px;
        background: rgba(0, 0, 0, 0.5);
        padding: 5px 0;
        border-radius: 30px;
        margin: 0 auto;
      }

      .btn_box {
        display: flex;
        align-items: center;
        justify-content: space-around;
        padding: 0 10px;

        .btn {
          color: #333;
          background: #fff;
          border-radius: 3px;
          padding: 4px 25px;
        }

        .personal_btn {
          border: none;
          border-color: 1px soild #fff;
        }

        .team_btn {
          color: #fff;
          background: #3E1976;
          border-color: #3E1976;
        }
      }
    }

    .player_list {
      padding: 20px 0;
      display: flex;
      flex-wrap: wrap;

      .list {
        width: 33.333333%;
        text-align: center;
        margin-bottom: 20px;

        .pic {
          width: 5.4rem;
          height: 5.4rem;
          border-radius: 50%;
          background: #fff;
          margin: 0 auto;
          box-shadow: 1px 2px 3px #333;
          overflow: hidden;
		  position:relative;
		.Serial{
			position: absolute;
			text-align: center;
			bottom: 0;
			width: 100%;
			height: 1rem;
			text-align: center;
			left: 0;
			font-size: 0.6rem;
			line-height: 1rem;
			background: rgba(0, 0, 0, .5);
      color: #fff;
		}
          .pic_is {
            width: 5.4rem;

          }
        }

        .name {
          margin: 10px 0 5px 0;
          font-size: 0.9rem;
          color: #333;
        }

        .vote_btn {
          background: #3E1976;
          color: #fff;
          border-radius: 30px;
          border: none;
          width: 5rem;
          padding: 0px 15px;
          font-size: 0.8rem;
          position: relative;
        }
      }

    }
  }
</style>



// WEBPACK FOOTER //
// src/components/vote.vue